import { CSSProperties, useState } from 'react';
import { ArrowContainer, Popover, PopoverAlign } from 'react-tiny-popover';
import { Color, Size, Styles } from '@vivli/shared/theme';

interface HoverTextProps {
    content: string | JSX.Element;
    align?: PopoverAlign;
    arrowColor?: any;
    children: JSX.Element;
    debounceMs?: number;
}

const contentStyle: CSSProperties = {
    backgroundColor: Color.WHITE,
    paddingBottom: Size.PADDING,
    paddingLeft: Size.PADDING,
    paddingRight: Size.PADDING,
    paddingTop: Size.PADDING,
    maxWidth: window.innerWidth - 2 * Size.PADDING,
    maxHeight: window.innerHeight - 2 * Size.PADDING,
    ...Styles.borderRadius(Size.SEARCH_BORDER_RADIUS_SIZE),
};

export const HoverTextComponent = ({ align, arrowColor, content, children }: HoverTextProps) => {
    const [isMouseOver, setIsMouseOver] = useState(false);

    return (
        <div onMouseEnter={() => setIsMouseOver(true)} onMouseLeave={() => setIsMouseOver(false)}>
            <Popover
                isOpen={isMouseOver}
                padding={Size.PADDING}
                align={align}
                containerStyle={{ filter: Styles.POPOVER_DROP_SHADOW, zIndex: '1' }}
                content={(props) => (
                    <ArrowContainer {...props} arrowColor={arrowColor} arrowSize={8}>
                        <div style={contentStyle}>{content}</div>
                    </ArrowContainer>
                )}
            >
                {children}
            </Popover>
        </div>
    );
};
